import { render, staticRenderFns } from "./ReviewQuestionnaire.vue?vue&type=template&id=3fb3b03b"
import script from "./ReviewQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./ReviewQuestionnaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports